// extracted by mini-css-extract-plugin
export default {"container":"Teams_container__iKaC5","useLabel":"Teams_useLabel__tYWaf","ul":"Teams_ul__GDQiI","child":"Teams_child__P3yk+","primary":"Teams_primary__Y2ACa"};